import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { UserDTO } from "../../../../common/types/UserDTO";
import { baseQuery } from "../../client/DefaultClient";

export const userService = createApi({
  reducerPath: "userService",
  baseQuery: fetchBaseQuery(baseQuery),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUser: builder.query<UserDTO, { id: number }>({
      query: ({ id }) => `api/identity/users/${id}`,
      providesTags: (user) => [{ type: "User", id: user?.id }],
    }),
  }),
});

export const { useGetUserQuery } = userService;
